<template>
    <div class="text-center d-flex align-items-center justify-content-center">
        <span :class="loadingClass" aria-hidden="true"></span>
        <span class="ms-2" role="status">{{ text }}</span>
    </div>
</template>

<script>
export default {
    name: 'Loader',
    props: {
        loadingClass: {
            type: String,
            default: 'spinner-border spinner-border-sm'
        },
        text: {
            type: String,
            default: 'Loading...'
        }
    }
}
</script>
